import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConcessionService {
  constructor(private http: HttpClient) { }

  getListeDeps(includes?: string[]) {
    let url = `${environment.apiUrl}/api/concessions/liste`;
    if (includes && includes.length > 0) {
      url += `?include=${includes.join(',')}`;
    }
    return this.http.get<any>(url);
  }

  getDetailConcession(concession: any, dep: any, includes?: string[]) {
    let url = `${environment.apiUrl}/api/concession/${concession}/${dep}`;
    if (includes && includes.length > 0) {
      url += `?include=${includes.join(',')}`;
    }
    return this.http.get<any>(url);
  }
  getDetailConcessionGen(concession: any, includes?: string[]) {
    let url = `${environment.apiUrl}/api/concession/${concession}/info`;
    if (includes && includes.length > 0) {
      url += `?include=${includes.join(',')}`;
    }
    return this.http.get<any>(url);
  }
  getDetailAgenceBytdm(agence: any) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/bytdm/${agence}`
    );
  }
  getListConcessions() {
    return this.http.get<any>(
      `${environment.apiUrl}/api/concessions/liste`
    );
  }
}
